// Dependencies
import { FC, useState, useCallback, MouseEventHandler } from "react";

// Components
import { Typography } from "@mui/material";
import { If } from "jsx-control-statements";
import { IconButton } from "~/components/Common";
import Categories from "../Categories/Categories";

// Icons
import SearchIcon from "@mui/icons-material/Search";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

// Types
import { TCategoryData } from "~/types";

// Styles
import { StyledNotFound } from "~/components/Layout";
import { StyledHeader, StyledWrapper } from "./CategoryPicker.styled";

interface CategoryPickerProps {
  data: TCategoryData[];
  onClose: MouseEventHandler;
  onSelect: Function;
}

const CategoryPicker: FC<CategoryPickerProps> = ({
  data,
  onClose,
  onSelect,
}) => {
  // states
  const [pickerTop, setPickerTop] = useState<number>(0);

  /** Calculate top position of picker to limit height */
  const pickerRef = useCallback((node: HTMLDivElement) => {
    if (node !== null) {
      setPickerTop(node.getBoundingClientRect().top);
    }
  }, []);

  return (
    <StyledWrapper
      sx={{
        maxHeight: `${window.innerHeight - pickerTop - 20}px`,
      }}
      ref={pickerRef}
    >
      <StyledHeader>
        <IconButton onClick={onClose}>
          <ChevronLeftIcon />
        </IconButton>
        <Typography variant={"h2"}>Category list</Typography>
        <IconButton onClick={() => {}}>
          <SearchIcon />
        </IconButton>
      </StyledHeader>
      <If condition={data.length}>
        <Categories data={data} onSelect={onSelect} />
      </If>
      <If condition={!data.length}>
        <StyledNotFound>No category found!</StyledNotFound>
      </If>
    </StyledWrapper>
  );
};

export default CategoryPicker;
